import axios from "axios";
import { environment } from "environments/environment";
import { onRequestSuccess, onResponseRejected } from "./interceptors";

const drProxPractitionerInstance = axios.create({
    baseURL: `${environment.protocol}${environment.gatewayIp}:${environment.gatewayPort}/drprox/api/v1`
});

drProxPractitionerInstance.interceptors.request.use(onRequestSuccess, undefined);
drProxPractitionerInstance.interceptors.response.use(undefined, onResponseRejected);

export default drProxPractitionerInstance;
